var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "internal-page-main-section faq-section-main forum-main col-12"
      },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "MainForum" }, [
            _c("div", { staticClass: "ForumTop" }, [
              _c("div", { staticClass: "ForumSearch" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search,
                        expression: "search"
                      }
                    ],
                    staticClass: "form-control bg-none border-0 forum-input",
                    attrs: {
                      type: "search",
                      placeholder: "What're you searching for?",
                      "aria-describedby": "button-addon4"
                    },
                    domProps: { value: _vm.search },
                    on: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.clearSearch.apply(null, arguments)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-prepend border-0" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link text-info clear-search",
                        attrs: { id: "button-clear", type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.updateSearchQuestion()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ForumButton" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary hvr-sweep-to-right-blue",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.clickAskQuestion()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                        Ask A New Post\n                    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  staticStyle: { display: "none" },
                  attrs: {
                    type: "button",
                    id: "openQuestionAsk",
                    "data-toggle": "modal",
                    "data-target": "#modal-1"
                  }
                },
                [
                  _vm._v(
                    "\n                        Ask A New Post\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ForumPage" }, [
              _c(
                "div",
                { staticClass: "ForumListing" },
                [
                  _c("h2", [_vm._v("Top Asked Posts")]),
                  _vm._v(" "),
                  _vm._l(_vm.questionList, function(queObj, index) {
                    return [
                      _c(
                        "div",
                        { key: index, staticClass: "ForumQue" },
                        [
                          queObj.is_pin_post
                            ? [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.clickQuestions(queObj.slug)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-thumb-tack",
                                      staticStyle: { "margin-right": "5px" },
                                      attrs: { "aria-hidden": "true" }
                                    }),
                                    _vm._v(
                                      "  " +
                                        _vm._s(queObj.question) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            : [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0);" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.clickQuestions(queObj.slug)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Q. " +
                                        _vm._s(queObj.question) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ]
                  })
                ],
                2
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _vm.totalQuestions > _vm.questionList.length
            ? _c("section", { staticClass: "container load_more_container" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-danger deleteMedia hvr-sweep-to-right-red",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.getQuestions()
                      }
                    }
                  },
                  [_vm._v("Load More")]
                )
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal",
        staticClass: "modal fade forum-modal",
        attrs: { id: "modal-1", role: "dialog" }
      },
      [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.resetModal()
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c(
                "form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.submitAnswer.apply(null, arguments)
                    }
                  }
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.question,
                        expression: "question"
                      }
                    ],
                    staticClass: "form-control form-control-lg",
                    attrs: { type: "text", placeholder: "Ask your Post" },
                    domProps: { value: _vm.question },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.question = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("font", { staticClass: "text-danger" }, [
                    _vm._v(_vm._s(_vm.questionError))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ForumPopupButton" }, [
                    _c(
                      "div",
                      {
                        staticClass: "dropZoneDiv",
                        staticStyle: { display: "none" }
                      },
                      [
                        _c("font", { staticClass: "text-danger" }, [
                          _vm._v(
                            "You can upload maximum " +
                              _vm._s(_vm.dropzoneOptions.maxFiles) +
                              " file's with a post."
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "vue-dropzone",
                          {
                            ref: "dropzone",
                            attrs: {
                              id: "dropzone",
                              options: _vm.dropzoneOptions,
                              useCustomSlot: true
                            },
                            on: {
                              "vdropzone-success": _vm.uploadDocument,
                              "vdropzone-removed-file": _vm.removedSelectedFile,
                              "vdropzone-error": _vm.fileError,
                              "vdropzone-file-added": _vm.fileAdd,
                              "vdropzone-total-upload-progress":
                                _vm.progressOfUload
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "dropzone-custom-content" },
                              [
                                _c(
                                  "h4",
                                  { staticClass: "dropzone-custom-title" },
                                  [
                                    _vm._v(
                                      "Drop files here or click to upload."
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "subtitle" }, [
                                  _vm._v("(Select files from your computer.)")
                                ])
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "askquestion btn btn-primary hvr-sweep-to-right-blue",
                        attrs: { type: "button", id: "SubmitQuestion" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.addQuestion()
                          }
                        }
                      },
                      [_vm._v("Ask Post")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "addlink hvr-sweep-to-right-red pull-right",
                        attrs: { href: "", id: "addImgBtn" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.toggleDropZone()
                          }
                        }
                      },
                      [_vm._v("Add image")]
                    )
                  ])
                ],
                1
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Forum ")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-link text-info",
        attrs: { id: "button-addon4", type: "button" }
      },
      [_c("i", { staticClass: "fa fa-search" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "modal-title" }, [
      _c("label", [_vm._v("Ask Post")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row pl-3" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          {
            staticClass: "mt-3 alert alert-danger",
            attrs: { id: "alertError" }
          },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-690200a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-690200a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forum.vue
// module id = null
// module chunks = 